import React, { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { Store } from '../Store';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getError } from '../utils';
import { api } from '../Api';

export default function CreatedIdsScreen() {
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const page = sp.get('page') || 1;
  const initData = [
    {
      from: '',
      to: 'Loading',
      amount: '',
      created: '',
    },
  ];

  const [totalUsers, setTotalUsers] = useState();
  const [totalPages, setTotalPages] = useState();
  const [history, setHistory] = useState(initData);
  const fetchData = async () => {
    try {
      const { data } = await axios.post(
        api + `/api/users/createdIds?page=${page}`,
        { username: userInfo.username },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      setHistory(data.products);
      setTotalPages(data.pages);
      setTotalUsers(data.countProducts);
    } catch (error) {
      toast.error(getError(error));
    }
  };
  useEffect(() => {
    fetchData();
  }, [page, userInfo]);

  function gotoHome() {
    navigate('/sales');
  }

  return (
    <div>
      <Helmet>
        <title>Created IDs</title>
      </Helmet>
      <Container className="no-gutter" style={{}}>
        <div className="card">
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <img
                src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                style={{ width: '15rem', margin: '2rem' }}
                alt="ClickCart Logo"
              />
            </Col>
          </Row>
          <div
            className="card-header"
            onClick={() => {
              gotoHome();
            }}
          >
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i> {'  '}{' '}
            Created IDs
          </div>
          <div className="card-body" style={{ margin: 'auto' }}></div>
          <Table responsive style={{ width: '95%', margin: 'auto' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Status</th>
                <th>Join Date</th>
              </tr>
            </thead>
            <tbody>
              {history.map((product) => (
                <tr key={product._id}>
                  <td>{product.name}</td>
                  <td>{product.username}</td>
                  <td>{product.isActiveId ? 'Active' : 'InActive'}</td>
                  <td>
                    {product.createdAt
                      ? product.createdAt.substring(0, 10)
                      : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <nav aria-label="..." style={{ margin: '1rem' }}>
            <ul className="pagination">
              <li className={`page-item${parseInt(page) === 1 ? ' disabled' : ''}`}>
                <Link className="page-link" to={`/createdids?page=${parseInt(page) - 1}`}>Previous</Link>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <li key={p} className={`page-item${parseInt(page) === p ? ' active' : ''}`}>
                  <Link className="page-link" to={`/createdids?page=${p}`}>{p}</Link>
                </li>
              ))}
              <li className={`page-item${parseInt(page) === totalPages ? ' disabled' : ''}`}>
                <Link className="page-link" to={`/createdids?page=${parseInt(page) + 1}`}>Next</Link>
              </li>
            </ul>
          </nav>

          <div style={{ height: '51vh' }}> {''}</div>
        </div>
      </Container>
    </div>
  );
}
